import Vue from 'vue'
import VueRouter from 'vue-router'
import video from '../views/video.vue'
import login from '../views/login.vue'
import callback from '../views/callback.vue'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    name: 'home',
    component: () => import('../views/home.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  // {
  //   path: '/videos',
  //   name: 'videos',
  //   component: videos
  // },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/About',
    name:'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/details/:id',
    name: 'details',
    component: () => import('../views/details.vue'),
    props: true
  },
  {
      path: '/video',
      name: 'video',
      component: video
    },
    {
      path: '/callback',
      name: 'callback',
      component: callback
    },
  {
    path: '/administration/:id',
    name: 'administration',
    component: () => import('../views/administration.vue'),
    props: true
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('../views/forget.vue'),
    props: true
  },
  
  {
    path: '/pay',
    name: 'pay',
    component: () => import('../views/pay.vue')
  },
  {
    path: '/wxLogin',
    name: 'wxLogin',
    component: () => import('../views/wxLogin.vue'),
  },
  {
    path: '/order/:id',
    name: 'order',
    component: () => import('../views/infoOrder.vue'),
    props:true
  },
  {
    path: '/payment/status',
    name: 'payment',
    component: () => import('../views/payment.vue')
  }
  // },
  // {
  //   path:'*',
  //   component: () => import('../views/404.vue'),
  // }
]

const router = new VueRouter({
  mode:'history',
  routes,
})

export default router
